import { RegvarModel } from './index';
export class RegvarValueDomainModel extends RegvarModel {
    findValue(options) {
        if (!this.value) {
            return null;
        }
        const result = options.find((x)=>x.id === this.value);
        if (!result) {
            throw new Error(`The value ${this.value} could not be found from the supplied options.`);
        }
        return result;
    }
}
